<template>
  <div class="mt-5">
    <v-simple-table>
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-center" v-for="header in headers" :key="header" style="background: #f1f1f1">
              <span class="titleText--text font-weight-bold" style="font-size: 14px">
              {{ header }}</span>
            </th>
          </tr>
        </thead>
        <tbody class="text-right">
          <tr v-for="(item, index) in tabledata" :key="index">
            <td class="titleText--text text-center" style="font-size: 14px">{{ item.variable }}</td>
            <td class="titleText--text">{{ String(item.max) | trgm_numberformate }}</td>
            <td class="titleText--text">{{ String(item.min) | trgm_numberformate }}</td>
            <td class="titleText--text">{{ String(item.mean) | trgm_numberformate }}</td>
            <td class="titleText--text">{{ String(item.median) | trgm_numberformate }}</td>
            <td class="titleText--text">
              <div style="width: '100%'; position: relative">
                <div
                  :style="{
                    background: '#f72525',
                    position: 'absolute',
                    width: normalizeData(item.Total_Period_1, item),
                    height: '100%',
                    opacity: '0.2',
                    right: 0,
                    border: 'px solid red',
                  }"
                  class="rounded"
                ></div>
                {{ new Intl.NumberFormat("gb-GB").format(item.Total_Period_1) }}
              </div>
            </td>
            <td class="titleText--text">
              <div style="width: '100%'; position: relative">
                <div
                  :style="{
                    background: '#f72525',
                    position: 'absolute',
                    width: normalizeData(item.Total_Period_2, item),
                    height: '100%',
                    opacity: '0.2',
                    right: 0,
                    border: '1px solid red',
                  }"
                  class="rounded"
                ></div>
                {{ new Intl.NumberFormat("en-US").format(item.Total_Period_2) }}
              </div>
            </td>
            <td class="titleText--text">
              <div style="width: '100%'; position: relative">
                <div
                  :style="{
                    background: '#f72525',
                    position: 'absolute',
                    width: normalizeData(item.Total_Period_3, item),
                    height: '100%',
                    opacity: '0.2',
                    right: 0,
                    border: '1px solid red',
                  }"
                  class="rounded"
                ></div>
                {{ new Intl.NumberFormat("en-US").format(item.Total_Period_3) }}
              </div>
            </td>
            <td class="titleText--text">
              <v-icon
                small
                color="green"
                style="margin-top: -2px"
                v-if="item.Period_2_vs_Period_1 >= 0"
                >mdi-arrow-up-thick</v-icon
              >
              <v-icon small color="red" v-else>mdi-arrow-down-thick</v-icon>
              {{ item.Period_2_vs_Period_1 }} %
            </td>
            <td class="titleText--text">
              <v-icon
                small
                color="green"
                style="margin-top: -2px"
                v-if="item.Period_3_vs_Period_2 >= 0"
                >mdi-arrow-up-thick</v-icon
              >
              <v-icon small color="red" v-else>mdi-arrow-down-thick</v-icon>
              {{ item.Period_3_vs_Period_2 }} %
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
export default {
  props: {
    data: null,
  },
  components: {},
  data() {
    return {
      tabledata: null,
      temptabledata: null,
      IndependentvariablesSelectedfilter: null,
      headers: [
        "Variables",
        "Max",
        "Min",
        "Mean",
        "Median",
        "TimeP1",
        "TimeP2",
        "TimeP3",
        "TimeP2 vs TimeP1",
        "TimeP3 vs TimeP2",
      ],
    };
  },
  methods: {
    normalizeData(value, item) {
      let min = Math.min(
        item.Total_Period_1,
        item.Total_Period_2,
        item.Total_Period_3
      );
      let max = Math.max(
        item.Total_Period_1,
        item.Total_Period_2,
        item.Total_Period_3
      );
      let result = ((value - min) / (max - min)) * 100;

      if (result <= 10) {
        result = (result + 5) * 10;
      }
      //alert(value);
      //alert(JSON.stringify(item));
      return `${result}%`;
    },
    binddata(vartabledata, IndependentvariablesSelected) {
      this.IndependentvariablesSelectedfilter = IndependentvariablesSelected;
     
       this.tabledata=[];
       this.temptabledata=[];
       let tempoutdata=[];
       this.temptabledata=vartabledata;
       for (let el in  this.temptabledata) {
        // alert(this.series[el].name);
        for (let k in this.IndependentvariablesSelectedfilter) {
          //alert("dd"+this.chartsFilter[k]);
          if ( this.temptabledata[el].variable === this.IndependentvariablesSelectedfilter[k]) {
            //alert(JSON.stringify(this.series[el]));
            
            tempoutdata.push( this.temptabledata[el]);
          }
        }
      }
      this.tabledata = tempoutdata;
      //this.tabledata = vartabledata;
    },
  },
};
</script>
<style>
table thead,
table tr {
  border-bottom: 1px solid #f1f1f1 !important
}</style>